/* eslint-disable no-unused-vars */
import React, { useState, useEffect } from 'react';
import './pagination.scss';
import ReactPaginate from 'react-paginate';

import { number, func } from 'prop-types';

export default function Pagination({
  itemsPerPage,
  totalItems,
  pageCount,
  currentPage,
  onSelect = () => {}
}) {
  const [itemOffset, setItemOffset] = useState(1);
  const [endOffset, setEndOffset] = useState(0);

  const updateEndOffSet = (page) => {
    setEndOffset(
      page * itemsPerPage <= totalItems ? page * itemsPerPage : totalItems
    );
  };

  useEffect(() => {
    updateEndOffSet(currentPage);
  }, [currentPage]);

  const handlePageClick = (event) => {
    const newOffset = ((event.selected * itemsPerPage) % totalItems) + 1;
    setItemOffset(newOffset);
    updateEndOffSet(event.selected + 1);
    onSelect(event.selected + 1);
  };

  return (
    <div className="pagination-wrapper" data-testid="pagination-component">
      <ReactPaginate
        breakLabel="..."
        nextLabel=""
        onPageChange={handlePageClick}
        pageRangeDisplayed={1}
        pageCount={pageCount}
        previousLabel=""
        renderOnZeroPageCount={null}
        forcePage={currentPage - 1}
      />
    </div>
  );
}

Pagination.propTypes = {
  itemsPerPage: number.isRequired,
  totalItems: number.isRequired,
  pageCount: number.isRequired,
  onSelect: func.isRequired,
  currentPage: number
};

Pagination.defaultProps = {
  currentPage: 1
};
